import React, { useState, useEffect, useRef, useCallback } from "react";
import Autocomplete from "react-autocomplete";
import { connect } from "react-redux";
import * as qs from "query-string";
import Select from "react-select";
import _ from "lodash";

import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";

import EnchancedSearch from "./EnhancedSearch";
import SidebarContent from "./SidebarContent";
import SearchResult from "./SearchResult";

import { FETCH_SEARCH_RESULTS_FAILURE } from "@safecv/actions/types";
import { handleURLChange } from "@safecv/shared/urlParams";
import API_CONFIG from "@safecv/src/api-config";
import {
  fetchAutopopulateResultsByKeyword,
  fetchSearchResultsByKeyword,
} from "@safecv/actions/postActions";
import "./Annotations.css";

import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

const GreenCheckbox = withStyles({
  root: {
    color: "#E2E8F0",
    "&$checked": {
      color: "#71CCA1",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const RedCheckbox = withStyles({
  root: {
    color: "#E2E8F0",
    "&$checked": {
      color: "#DA8787;",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const groupByOptions = [
  { value: "ruleIndex", label: "Code" },
  { value: "pageNo", label: "Page, Sheet Index" },
  { value: "ruleNo", label: "Rule" },
];

const colourStyles = {
  container: (styles) => ({
    ...styles,
    zIndex: 2,
    width: "50%",
    fontFamily: "Lato",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "12px",
  }),
  control: (styles) => ({
    ...styles,
    marginBottom: 0,
    boxShadow: "none",
    borderRadius: "0px",
    borderStyle: "none",
    borderBottom: "1px solid #4183c5",
    cursor: "pointer",
    height: "35px",
    "&:hover, &:focus": {
      borderBottom: "1px solid #4183c5",
    },
  }),
  singleValue: (styles) => ({
    ...styles,
    color: "#545a5d",
    fontWeight: "normal",
  }),
  menu: (styles) => ({
    ...styles,
    marginTop: 4,
  }),
};

const keysToConsider = [
  "annotationGenericMessage",
  "annotationName",
  "annotationSpecificMessage",
  "annotationType",
  "codebookDescription",
  "id",
  "information",
  "itemName",
  "notes",
  "pageNo",
  "resourceType",
  "ruleNo",
  "ruleIndex",
  "sheetName",
  "sheetNumber",
];

const searchPlaceholder = {
  symbols: "Symbols Search",
  annotated: "Annotation Search",
  violation: "Violation Search",
  compliance: "Compliance Search",
  "violation,compliance": "Compliance,Violation Search",
  "compliance,violation": "Compliance,Violation Search",
};

const Annotations = (props) => {
  const urlSearch = qs.parse(window.location.search);
  const groupByKey = groupByOptions.filter((obj) => {
    return urlSearch.groupBy?.includes(obj.value);
  });
  const [groupByValue, setGroupByValue] = useState(null);
  const [groupBySelectedOption, setGroupBySelectedOption] = useState(
    groupByKey[0] ? groupByKey[0] : groupByOptions[0]
  );
  const [selectedValue, setSelectedValue] = useState(urlSearch.search || null);
  const [searchValue, setSearchValue] = useState(urlSearch.search || "");
  const [previousState, setPreviousState] = useState(null);
  const debounceValue = useRef(
    _.debounce((searchText) => {
      fetchAutopopulateResultsByKeyword(jobId, searchText);
    }, 300)
  );

  useEffect(() => {
    if (props?.viewType === "enhancedSearch") {
      setSearchTypeSelected("Enhanced");
    } else if (props?.viewType === "basicPdfSearch") {
      setSearchTypeSelected("Basicpdf");
    }
  }, [props?.viewType]);

  const [searchTypeSelected, setSearchTypeSelected] = useState("Basicpdf");
  const [checkBoxValue, setCheckBoxValue] = useState([
    {
      id: 1,
      isChecked: true,
      name: "compliance",
      label: "Compliances",
    },
    {
      id: 2,
      isChecked: true,
      name: "violation",
      label: "Violations",
    },
  ]);

  const {
    jobId,
    viewType,
    annotationData,
    setSelectedAnnotation,
    discardedData,
    setSelectedAnnotationUuid,
    planStatus,
    isDiscardedOpen,
    searchPayload,
    spinnerLoading,
    autopopulatePayload,
    fetchSearchResultsByKeyword,
    fetchAutopopulateResultsByKeyword,
    isSearchEnable,
    selectedSearchResult,
    setSelectedSearchResult,
    resetSearchValues,
    selectedAnnotation,
    setRestoredAnnotationId,
    selectedCompliancesCheckboxValue,
    setSelectedCompliancesCheckboxValue,
    selectedEnhancedSearch,
    setSelectedEnhancedSearch,
    setSelectedGroupEnhancedSearch,
    annotationRefs,
    setViewType,
    filteredData,
    setFilteredData,
    annotationSearchedValue,
    setAnnotationSearchedValue,
    isReconciliationSidebarOpen,
  } = props;

  let autopopulateData = autopopulatePayload.map((option) => {
    return { value: option.order, label: option.value };
  });

  autopopulateData.length <= 0 &&
    autopopulateData.unshift({
      value: searchValue,
      label: searchValue,
    });

  const changeGroupBy = (selectedOption) => {
    setGroupBySelectedOption(selectedOption);
    handleURLChange({ groupBy: selectedOption.value });
  };

  const onChange = (val) => {
    setSearchValue(val);
    // sameElementID: false,
    debounceValue.current(val);
  };

  const onSelect = (val) => {
    setSearchValue(val);
    setSelectedValue(val);
    if (!urlSearch.textId) {
      setPreviousState(urlSearch);
    }
    fetchSearchResultsByKeyword(jobId, val);
    // handleURLChange({
    //   annotationId: "",
    //   search: val,
    //   textId: "",
    //   [this.state.groupBy]: "",
    // });
  };

  const getItemValue = (item) => {
    return item.label;
  };

  const renderItem = (item, isHighlighted) => {
    return (
      <div
        style={{
          padding: "10px 15px",
          borderBottom: "1px solid #E2E8F0",
          color: isHighlighted ? "#4183c5" : "black",
        }}
      >
        {(item = item.label)}
      </div>
    );
  };

  useEffect(() => {
    if (!isSearchEnable && searchPayload) {
      resetSearchValues();
      setSearchValue("");
    }
  }, [isSearchEnable]);

  useEffect(() => {
    if (!isReconciliationSidebarOpen) {
      resetSearchValues();
      setSearchValue("");
    }
  }, [isReconciliationSidebarOpen]);

  const handleCheckBoxChange = (id, name) => {
    let clonedCheckBoxValue = [...checkBoxValue];
    let clonedSelectedValue = [...selectedCompliancesCheckboxValue];
    if (clonedSelectedValue.length === 1 && clonedSelectedValue[0] === name)
      return;
    clonedCheckBoxValue.forEach((input) => {
      if (input.id === id) {
        input.isChecked = !input.isChecked;
        if (input.isChecked) {
          clonedSelectedValue.push(name);
        } else {
          const index = clonedSelectedValue.indexOf(name);
          if (index > -1) {
            clonedSelectedValue.splice(index, 1);
          }
        }
        setCheckBoxValue(clonedCheckBoxValue);
        setSelectedCompliancesCheckboxValue(clonedSelectedValue);
        return;
      }
    });
    setViewType(clonedSelectedValue.join(","));
  };

  const filterAnnotation = (searchedValue, annotations) => {
    if (searchedValue === "") {
      setFilteredData(null);
    } else {
      const filteredAnnotation = annotations.filter((annotation) => {
        let flag = false;
        for (let i = 0; i < keysToConsider.length; i++) {
          if (
            annotation[keysToConsider[i]] &&
            String(annotation[keysToConsider[i]])
              .toLowerCase()
              .includes(searchedValue.toLowerCase())
          ) {
            flag = true;
            break;
          }
        }
        if (flag) return annotation;
      });
      setFilteredData(filteredAnnotation);
    }
  };

  const debounceSearchedValue = useRef(_.debounce(filterAnnotation, 500));

  const handleUserKeyPress = useCallback(
    (event) => {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Clear the search results
        searchValue === "" && fetchSearchResultsByKeyword(jobId, searchValue);
      }
    },
    [searchValue]
  );

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  return (
    <div
      className={`sidebar-content-container ${
        viewType !== "annotated" ? "sidebar-search-container" : ""
      }`}
    >
      {/* group by option will be available in annotation and compliance view */}
      {jobId &&
      jobId > API_CONFIG.FEATURE_FTS_ENABLED_FROM &&
      isSearchEnable ? (
        <div
          className={
            searchTypeSelected === "Basicpdf"
              ? "search-container"
              : "search-container height-full"
          }
        >
          <div className="search-typeselection">
            <div
              className={`search-typeselection-width 
                  ${
                    searchTypeSelected === "Basicpdf"
                      ? "search-typeselection-text-selected"
                      : "search-typeselection-text-nonselected"
                  }`}
              onClick={() => {
                setViewType("basicPdfSearch");
                setSearchTypeSelected("Basicpdf");
              }}
            >
              Basic PDF Search
            </div>
            <div
              className={`search-typeselection-width 
                  ${
                    searchTypeSelected === "Enhanced"
                      ? "search-typeselection-text-selected"
                      : "search-typeselection-text-nonselected"
                  }`}
              onClick={() => {
                setViewType("enhancedSearch");
                setSearchTypeSelected("Enhanced");
              }}
            >
              Enhanced Search
            </div>
          </div>
          {searchTypeSelected === "Basicpdf" ? (
            <div className="search-group">
              <IconButton
                className="search-icon"
                aria-label="search"
                disabled={true}
              >
                <SearchIcon />
              </IconButton>
              <Autocomplete
                wrapperStyle={{
                  alignSelf: "center",
                }}
                inputProps={{
                  style: {
                    border: "none",
                    fontFamily: "Lato",
                    fontSize: "12px",
                    color: "#303B4A",
                  },
                }}
                className="anno-searchbox"
                getItemValue={getItemValue}
                items={searchValue ? autopopulateData : []}
                renderItem={renderItem}
                menuStyle={{
                  zIndex: "100",
                  position: "absolute",
                  background: "white",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  overflowY: "auto",
                  maxHeight: "300px",
                  minHeight: "0px",
                  cursor: "pointer",
                }}
                value={searchValue}
                onChange={(e) => onChange(e.target.value)}
                onSelect={onSelect}
              />
            </div>
          ) : (
            <EnchancedSearch
              jobId={jobId}
              selectedEnhancedSearch={selectedEnhancedSearch}
              setSelectedEnhancedSearch={setSelectedEnhancedSearch}
              setSelectedGroupEnhancedSearch={setSelectedGroupEnhancedSearch}
            />
          )}
        </div>
      ) : (
        <div className="search-group-container">
          {(viewType?.split(",").includes("compliance") ||
            viewType?.split(",").includes("violation")) && (
            <div className="complaince-checkbox-container">
              {checkBoxValue.map((value, index) => {
                return (
                  <div key={index} className="complaince-checkbox-individual">
                    <div>
                      {value.id === 1 ? (
                        <GreenCheckbox
                          disableRipple
                          checked={selectedCompliancesCheckboxValue.includes(
                            value.name
                          )}
                          onClick={() =>
                            handleCheckBoxChange(value.id, value.name)
                          }
                        />
                      ) : (
                        <RedCheckbox
                          disableRipple
                          checked={selectedCompliancesCheckboxValue.includes(
                            value.name
                          )}
                          onClick={() =>
                            handleCheckBoxChange(value.id, value.name)
                          }
                        />
                      )}
                    </div>
                    <div className="complaince-checkbox-individual-label">
                      {value.label}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {!isDiscardedOpen && (
            <React.Fragment>
              {viewType !== "symbols" && (
                <div className="group-by-container">
                  <div className="group-by-label"> Group Annotations by </div>
                  <Select
                    value={groupBySelectedOption}
                    styles={colourStyles}
                    options={groupByOptions}
                    onChange={changeGroupBy}
                    title={groupBySelectedOption}
                  />
                </div>
              )}
              <div className="annotation-search-group">
                <IconButton
                  className="search-icon"
                  aria-label="search"
                  disabled={true}
                >
                  <SearchIcon />
                </IconButton>
                <input
                  type="text"
                  name="annotationSearch"
                  value={annotationSearchedValue}
                  className="annotation-search-input"
                  placeholder={searchPlaceholder[viewType]}
                  onChange={(e) => {
                    setAnnotationSearchedValue(e.target.value);
                    debounceSearchedValue.current(
                      e.target.value,
                      annotationData
                    );
                  }}
                />
                {filteredData && (
                  <div
                    className="annotation-search-close"
                    onClick={() => {
                      setFilteredData(null);
                      setAnnotationSearchedValue("");
                    }}
                  >
                    X
                  </div>
                )}
              </div>
            </React.Fragment>
          )}
        </div>
      )}

      {!isSearchEnable ? (
        <SidebarContent
          focusPage={parseInt(1)}
          viewType={viewType}
          groupBy={groupBySelectedOption.value}
          groupByValue={groupByValue}
          setGroupByValue={setGroupByValue}
          setSelectedAnnotation={setSelectedAnnotation}
          items={
            isDiscardedOpen
              ? discardedData
              : filteredData
              ? filteredData
              : annotationData
          }
          jobId={jobId}
          setSelectedAnnotationUuid={setSelectedAnnotationUuid}
          planStatus={planStatus}
          isDiscardedOpen={isDiscardedOpen}
          selectedAnnotation={selectedAnnotation}
          setRestoredAnnotationId={setRestoredAnnotationId}
          loader={spinnerLoading}
          selectedCompliancesCheckboxValue={selectedCompliancesCheckboxValue}
          annotationRefs={annotationRefs}
          setSelectedSearchResult={setSelectedSearchResult}
        />
      ) : (
        <>
          {searchTypeSelected === "Basicpdf" ? (
            <SearchResult
              loader={spinnerLoading}
              searchResults={searchPayload}
              selectedValue={selectedValue}
              selectedSearchResult={selectedSearchResult}
              setSelectedSearchResult={setSelectedSearchResult}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

const mapStatetoProps = (state) => ({
  searchPayload: state.verification.searchResults,
  autopopulatePayload: state.verification.autopopulateResults,
  spinnerLoading: state.verification.spinnerLoading,
});

const mapDispatchtoProps = (dispatch) => {
  return {
    fetchSearchResultsByKeyword: (jobId, keyword) => {
      dispatch(fetchSearchResultsByKeyword(jobId, keyword));
    },
    fetchAutopopulateResultsByKeyword: (jobId, keyword) => {
      dispatch(fetchAutopopulateResultsByKeyword(jobId, keyword));
    },
    resetSearchValues: () => {
      dispatch({ type: FETCH_SEARCH_RESULTS_FAILURE });
    },
  };
};

export default connect(mapStatetoProps, mapDispatchtoProps)(Annotations);
